import { RouteConfig } from "vue-router";

const inicio: RouteConfig = {
  path: "/",
  name: "inicio",
  component: () => import(/* webpackChunkName: "inicio" */ "@/views/Inicio.vue"),
};

export default inicio;
